
// #region API_AUTH = '/api/auth'
export const API_AUTH = '/api/auth';
export const API_AUTH_LOGIN = `${API_AUTH}/login`;
export const API_AUTH_PASSWORD = `${API_AUTH}/password-set`;
export const API_AUTH_REGISTRATION = `${API_AUTH}/registration`;
export const API_AUTH_CODE = `${API_AUTH}/code`;
export const API_AUTH_REFRESH = `${API_AUTH}/refresh`;
export const API_AUTH_ME = `${API_AUTH}/me`;
// #endregion

// #region API_SHARED = 'api/shared'
export const API_SHARED = 'api/shared';
export const API_VERSION = `${API_SHARED}/version`
export const API_SEND_MESSAGE = `${API_SHARED}/message-from-site`
// #endregion

// #region API_DARTS = 'api/darts'
export const API_DARTS = 'api/darts';
export const API_DARTS_FILTER_TOURNAMENTS = `${API_DARTS}/filtered-tournaments-games`;
export const API_DARTS_FIRSTPLAYER = `${API_DARTS}/first-player`;
export const API_DARTS_GAME_STATUS = `${API_DARTS}/game-status`;
export const API_DARTS_UNDO_LAST_ACTION = `${API_DARTS}/undo-last-action`;
export const API_DARTS_THROW_DOUBLEATTEMPT = `${API_DARTS}/double-attempt`;
export const API_DARTS_THROW = `${API_DARTS}/throw`;
export const API_DARTS_SCORE_INIT = `${API_DARTS}/game-scoring-init`;
// #endregion

export const API_DARTS_GAMES = 'api/darts-games';
export const API_ERROR_LOGGER = 'api/Error/';
export const API_ONDLL_CRUD = 'api/mss-cms/news';
export const API_ONDLL_NEWS = 'api/mss-cms/news';
export const API_CLIENTS = 'api/clients';
export const API_USERS = 'api/users';
export const API_USERS_INIT = 'api/users/init';
export const API_ROLES = 'api/roles';
export const API_PERMISSIONS_DICTIONARY = 'api/permissions/dictionary';
export const API_CLIENT_PERMISSIONS_READ = 'api/permissions/client/read';
export const API_USER_PERMISSIONS_READ = 'api/permissions/user/read';
export const API_CURRENT_USER_PERMISSIONS_READ = 'api/permissions/try';
export const API_DARTS_TOURNAMENT_INIT = 'api/darts-tournaments/init';
export const API_DARTS_TOURNAMENTS = 'api/darts-tournaments'
export const API_DARTS_TOUR_PLAYERS = 'api/darts-players/list'
export const API_DARTS_TOUR_SELECTED_PLAYERS = 'api/darts-players/selected-list'
export const API_DARTS_WEEKS = 'api/darts-weeks'
export const API_DARTS_PHASE = 'api/darts-series'
export const API_COMPETITIONS = 'api/competitions'
export const API_COMPETITIONS_INIT = 'api/competitions/init'
export const API_PLAYERS_PHOTO = 'api/darts-player-pictures';
export const API_PLAYERS = 'api/darts-players'
export const API_DARTS_GAMES_INIT_DATA = 'api/darts-games/init'
export const API_DARTS_SHOOTOUT_GAMES = 'api/darts-games-shootout';
export const API_DARTS_ADC_GAMES = 'api/darts-games-adc'
export const API_DARTS_LISTENERS = 'api/listeners'
export const API_DARTS_LISTENERS_INIT = 'api/listeners/init'
export const API_EXCEPTIONS = "api/dashboard/log-exceptions"
export const API_MESSAGES = "api/dashboard/log-messages"
export const API_CONNECTIONS = "api/dashboard/log-connections"

export const API_DARTS_EVENT_MANAGER = '/api/darts-event-manager';
export const API_DARTS_EVENT_MANAGER_HEADER = `${API_DARTS_EVENT_MANAGER}/header`;
export const API_DARTS_EVENT_MANAGER_GAME = `${API_DARTS_EVENT_MANAGER}/games`;

// #region API_DARTS_STATS = 'api/darts-statistics'
export const API_DARTS_STATS = 'api/darts-statistics';
export const API_POST_MATCH = `${API_DARTS_STATS}/post-match`;
export const API_PRE_MATCH = `${API_DARTS_STATS}/pre-match`;
export const API_LEAGUE_TABLE = `${API_DARTS_STATS}/league-table`;
export const GAMES_SCV_STATS = `${API_DARTS_STATS}/form-statistics-games`
export const PLAYERS_SCV_STATS = `${API_DARTS_STATS}/form-statistics-player`
export const STATISTICS_INIT = `${API_DARTS_STATS}/form-statistics-init`
export const API_DARTS_SCOREBOARD_STATS = `${API_DARTS_STATS}/score-board-init`
export const API_DARTS_ACTIVE_GAME_SCORE = `${API_DARTS_STATS}/active-game-score`
export const API_LIVE_SCORE_INIT = `${API_DARTS_STATS}/live-score-init`
export const API_LIVE_SCORE_INIT_BY_TOUR = `${API_DARTS_STATS}/live-score-init-by-tournament`
export const API_LIVE_SCORE_SIDEBAR = `${API_DARTS_STATS}/live-score-sidebar`
export const API_DARTS_ACTIVE_GAME_SCORE_SHOOTOUT = `${API_DARTS_STATS}/active-game-score/shootout`
export const API_DARTS_STATS_GET_CSV = `${API_DARTS_STATS}/get-csv-file`
// #endregion

